import { render, staticRenderFns } from "./Notenberechnung.vue?vue&type=template&id=db5fb4ba"
import script from "./Notenberechnung.vue?vue&type=script&lang=js"
export * from "./Notenberechnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports